import { useQuery } from "@tanstack/react-query";
import { getWorkspacePlans } from "api/services/workspace-plan-service";
import { IWorkspacePlanModel } from "api/models/response/workspacePlan/IWorkspacePlanModel";
import { WORKSPACE_PLANS_QUERY_KEY } from "hooks/workspacePlan/queryKeys";

export const useGetWorkspacePlans = () => {
    const query = useQuery({
        queryKey: WORKSPACE_PLANS_QUERY_KEY,
        queryFn: async (): Promise<IWorkspacePlanModel[]> => {
            const response = await getWorkspacePlans();
            if (!response.success) {
                throw new Error(response.message ?? "subscriptionPlan.plansLoadError");
            }

            return response.data ?? [];
        },
    });

    return {
        plans: query.data ?? [],
        plansLoading: query.isLoading,
        plansRefetching: query.isFetching && !query.isLoading,
        plansError: query.isError,
        refetchPlans: query.refetch,
    };
};
